/**
 * Copyright (c) 2018-2023, BOTLabs GmbH.
 *
 * This source code is licensed under the BSD 4-Clause "Original" license
 * found in the LICENSE file in the root directory of this source tree.
 */
export const verificationKeyTypesMap = {
    // proposed and used by dock.io, e.g. https://github.com/w3c-ccg/security-vocab/issues/32, https://github.com/docknetwork/sdk/blob/9c818b03bfb4fdf144c20678169c7aad3935ad96/src/utils/vc/contexts/security_context.js
    sr25519: 'Sr25519VerificationKey2020',
    // these are part of current w3 security vocab, see e.g. https://www.w3.org/ns/did/v1
    ed25519: 'Ed25519VerificationKey2018',
    ecdsa: 'EcdsaSecp256k1VerificationKey2019',
};
export const encryptionKeyTypesMap = {
    x25519: 'X25519KeyAgreementKey2019',
};
